export const ConversationAction = {
  listUnReadMessage: "listUnReadMessage",
  updateConversationState: "updateConversationState",
  deleteUnReadMessage: "deleteUnReadMessage",
  readConversationAction: "readConversationAction",
  receivedReadConversation: "receivedReadConversation",
  receivedCreateQcUnreadConversation: "receivedCreateQcUnreadConversation",
  receivedCreateQcUnrepliedConversation: "receivedCreateQcUnrepliedConversation",
  receivedCreateUnReadMessage: "receivedCreateUnReadMessage",
  subscribeConversations: "subscribeConversations",
  unsubscribeConversations: "unsubscribeConversations",
  addConversation: "addConversation",
  runningEllipse: "runningEllipse",
  guestRunningEllipse: "guestRunningEllipse",
  // Subscription
  addSubscriptionsOnPage: "addSubscriptionsOnPage",
  addEventDataList: "addEventDataList",
  startSubscription: "startSubscription",
  setHasStartedAppSyncSubscription: "setHasStartedAppSyncSubscription",
  unsubscribeAll: "unsubscribeAll",
  startVoiceChaInRoom: "startVoiceChatInRoom",
  respondVoiceChatInRoom: "respondVoiceChatInRoom",
  // Guest / User
  setCurrentMessages: "setCurrentMessages",
  addMessageToCurrentMessages: "addMessageToCurrentMessages",
  addMessagesToCurrentMessages: "addMessagesToCurrentMessages",
  updateMessageInCurrentMessages: "updateMessageInCurrentMessages",
  deleteMessageFromCurrentMessages: "deleteMessageFromCurrentMessages",
  noStaffCanRespondVoiceChatNotification: "noStaffCanRespondVoiceChatNotification",
  ticketQueueStopInquiry: "ticketQueueStopInquiry", // Notify guest that ticket is rejected by BE
  showGuestLoading: "showGuestLoading",
  pmsRoomServiceOrderFailed: "pmsRoomServiceOrderFailed",
  pmsRoomServiceOrdered: "pmsRoomServiceOrdered",
  firstMessageFromGuest: "firstMessageFromGuest",
  disableIncognitoModeNotification: "disableIncognitoModeNotification",
  alreadyNotifiedIncognitoMode: "alreadyNotifiedIncognitoMode",
  notifyIncognitoMode: "notifyIncognitoMode",
  // Staff
  setCurrentMessagesWithStaff: "setCurrentMessagesWithStaff",
  addMessageToCurrentMessagesWithStaff: "addMessageToCurrentMessagesWithStaff",
  addMessagesToCurrentMessagesWithStaff: "addMessagesToCurrentMessagesWithStaff",
  updateMessageInCurrentMessagesWithStaff: "updateMessageInCurrentMessagesWithStaff",
  showNewIcon: "showNewIcon",
  unAssignedInquiryList: "unAssignedInquiryList",
  setImportance: "setImportance",
  setForwardInquiryId: "setForwardInquiryId",
  setFromInquiryHistory: "setFromInquiryHistory",
  ticketQueueConversationReloadNeeded: "ticketQueueConversationReloadNeeded",
  noStaffCanRespondLiveChat: "noStaffCanRespondLiveChat",
  unreadMessages: "unreadMessages",
};

export const ConversationMutation = {
  SET_VOICE_TO_TEXT_ACTION: "VOICE_TO_TEXT_ACTION", // show/hide voice input window
  SET_SUBSCRIBED_UNREAD: "SUBSCRIBED_UNREAD", // conversation -> 作成したサブスクリプションのオブジェクトを覚えておいて、ユーザーや会話が切り替わるなど、Subscribeする必要が無くなったタイミングで消すためのもの
  SET_PUSH_UNREAD: "PUSH_UNREAD",
  SET_DELETE_UNREAD: "DELETE_UNREAD",
  SET_LOAD_UNREAD: "LOAD_UNREAD",
  SET_SUBSCRIPTIONS_ON_PAGE: "SET_SUBSCRIPTIONS_ON_PAGE",
  SET_EVENT_DATA_LIST: "SET_EVENT_DATA_LIST",
  SET_HAS_STARTED_APPSYNC_SUBSCRIPTION: "SET_HAS_STARTED_APPSYNC_SUBSCRIPTION",
  SET_UNSUBSCRIBE_ALL: "SET_UNSUBSCRIBE_ALL",
  START_SUBSCRIPTION: "START_SUBSCRIPTION",
  SET_CURRENT_MESSAGES: "SET_CURRENT_MESSAGES",
  SET_CURRENT_MESSAGES_WITH_STAFF: "SET_CURRENT_MESSAGES_WITH_STAFF",
  SET_CURRENT_CONVERSATION_ID: "SET_CURRENT_CONVERSATION_ID",
  SET_CURRENT_CONVERSATION_ID_WITH_STAFF: "SET_CURRENT_CONVERSATION_ID_WITH_STAFF",
  SET_CURRENT_CONVERSATION_HIDE_CONTACT: "SET_CURRENT_CONVERSATION_HIDE_CONTACT",
  SET_CONVERSATION_IDS: "SET_CONVERSATION_IDS",
  CLEAR_CONVERSATION_IDS: "CLEAR_CONVERSATION_IDS",
  ADD_CONVERSATION_ID: "ADD_CONVERSATION_ID",
  ADD_SURVEY_SCORE: "ADD_SURVEY_SCORE",
  START_VOICE_CHAT_IN_ROOM: "START_VOICE_CHAT_IN_ROOM",
  RESPOND_VOICE_CHAT_IN_ROOM: "RESPOND_VOICE_CHAT_IN_ROOM",
  SET_SHOW_NEW_ICON: "SET_SHOW_NEW_ICON",
  SET_IMPORTANCE: "SET_IMPORTANCE",
  SET_FORWARD_INQUIRY_ID: "SET_FORWARD_INQUIRY_ID",
  SET_FROM_INQUIRY_HISTORY: "SET_FROM_INQUIRY_HISTORY",
  SET_IS_CONTACT_BUTTON_VIEW: "SET_IS_CONTACT_BUTTON_VIEW",
  SET_NO_STAFF_CAN_RESPOND_VOICE_CHAT_NOTIFICATION: "SET_NO_STAFF_CAN_RESPOND_VOICE_CHAT_NOTIFICATION",
  SET_TICKET_QUEUE_STOP_INQUIRY: "SET_TICKET_QUEUE_STOP_INQUIRY",
  SET_SHOW_GUEST_LOADING: "SET_SHOW_GUEST_LOADING",
  SET_RUNNING_ELLIPSE: "SET_RUNNING_ELLIPSE",
  SET_GUEST_RUNNING_ELLIPSE: "SET_GUEST_RUNNING_ELLIPSE",
  SET_PWA_GUEST_RUNNING_ELLIPSE: "SET_PWA_GUEST_RUNNING_ELLIPSE",
  SET_FIRST_MESSAGE_FROM_GUEST: "SET_FIRST_MESSAGE_FROM_GUEST",
  SET_UNREAD_MESSAGES: "SET_UNREAD_MESSAGES",
  DISABLE_INCOGNITO_MODE_NOTIFICATION: "DISABLE_INCOGNITO_MODE_NOTIFICATION",
  ALREADY_NOTIFIED_INCOGNITO_MODE: "ALREADY_NOTIFIED_INCOGNITO_MODE",
  NOTIFY_INCOGNITO_MODE: "NOTIFY_INCOGNITO_MODE",
};

export type UnReadMessage = {
  id: number;
  conversationId: string;
  messageId: string;
  sendUserId: number;
  unReadUserId: number;
};

// export type SubscriptionData = {
//   key: string;
//   subscription: ZenObservable.Subscription;
// };

export type UnReadMessagesByGuest = {
  conversationId: string;
  lastMsgId: string;
  unreadIds: string[];
};
